import { render, staticRenderFns } from "./OSMMenu.vue?vue&type=template&id=e940be7c"
import script from "./OSMMenu.vue?vue&type=script&lang=js"
export * from "./OSMMenu.vue?vue&type=script&lang=js"
import style0 from "./OSMMenu.vue?vue&type=style&index=0&id=e940be7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports